/**
 * Returns true if preview data is available in the FlexibleUiDataContext
 * @param context is the FlexibleUiDataContext
 */
export const isFlexUiPreviewPresent = context => Boolean(context && context.preview);